<div class="main-card shadow-sm h-100">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex align-items-center gap-2">
      <fa-icon [icon]="faWrench" style="font-size: 14px; color: #00305C;"></fa-icon>
      <span class="main-heading fw-smbold">Services</span>
    </div>
    @if (servicesList.length > 5) {
      <button class="btn view-all-btn d-flex align-items-center gap-1" (click)="viewAllServices(servicesModal)">
        View all <fa-icon [icon]="faChevronRight" style="font-size: 10px;"></fa-icon>
      </button>
    }
  </div>

  <!-- Highlight Cards -->
  <div class="row g-2 mb-3">
    <div class="col-6">
      <div class="highlight-card h-100">
        <div class="highlight-heading mb-1">Total Jobs</div>
        <div class="blue-value fw-bold">{{ totalJobs | number }}</div>
      </div>
    </div>
    <div class="col-6">
      <div class="highlight-card h-100">
        <div class="highlight-heading mb-1">Service Value</div>
        <div class="blue-value fw-bold">{{ serviceValue | number }}</div>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="table-box">
    <table class="table custom-table border-0 mb-0">
      <thead>
        <tr>
          <th class="fw-smbold border-0">Service</th>
          <th class="text-end fw-smbold border-0">Jobs</th>
          <th class="text-end fw-smbold border-0">Value</th>
        </tr>
      </thead>
      <tbody>
        <!-- Loader State -->
        @if (loader) {
          <tr>
            <td colspan="3" class="text-center py-4 border-0">
              <app-loader [loadingIcon]="loader"></app-loader>
            </td>
          </tr>
        }
        <!-- Error State -->
        @if (!loader && errMsg) {
          <tr>
            <td colspan="3" class="text-center py-4 border-0">
              <p class="text-danger mb-0 small fw-bold">{{ errMsg }}</p>
            </td>
          </tr>
        }
        <!-- Data State -->
        @if (!loader && !errMsg) {
          @for (item of servicesList | slice:0:5; track item) {
            <tr>
              <td class="col-1-text border-0">{{ item.serviceName }}</td>
              <td class="text-end col-2-text fw-smbold border-0">
                @if (item.jobs !== null) {
                  {{ item.jobs | number }}
                } @else {
                  -
                }
              </td>
              <td class="text-end col-3-text fw-bold border-0">
                @if ((item.value || item.sales) !== null) {
                  {{ item.value || item.sales | number}}
                } @else {
                  -
                }
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</div>

<ng-template #servicesModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="fw-bold mb-0 main-heading">All Services</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="modal-body p-2 p-md-4">
    <div class="table-responsive table-container pe-md-2 pe-1">
      <table class="table custom-table border-0 mb-0">
        <thead>
          <tr>
            <th class="fw-smbold border-0">Service</th>
            <th class="text-end fw-smbold border-0">Jobs</th>
            <th class="text-end fw-smbold border-0">Value</th>
          </tr>
        </thead>
        <tbody>
          @if (servicesList.length > 0) {
            @for (item of servicesList; track item) {
              <tr>
                <td class="col-1-text border-0">{{ item.serviceName }}</td>
                <td class="text-end col-2-text fw-smbold border-0">
                  @if (item.jobs !== null) {
                    {{ item.jobs | number }}
                  } @else {
                    -
                  }
                </td>
                <td class="text-end col-3-text fw-bold border-0">
                  @if ((item.value || item.sales) !== null) {
                    {{ item.value || item.sales | number }}
                  } @else {
                    -
                  }
                </td>
              </tr>
            }
          }
          @if (servicesList.length === 0) {
            <tr>
              <td colspan="3" class="text-center py-4 border-0">
                <p class="text-muted mb-0 small fw-bold">No services data found.</p>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

